import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  useTheme,
  Chip,
} from '@mui/material'
import { PictureAsPdf, FolderZip, Lock } from '@mui/icons-material'
import { useStore } from 'src/utilities/hooks/useStore'
import { observer } from 'mobx-react-lite'

export type DownloadFormat = 'pdf' | 'pdf_ubl'

interface DownloadFormatModalProps {
  open: boolean
  onClose: () => void
  onSelect: (format: DownloadFormat) => void
  loading?: boolean
}

export const DownloadFormatModal = observer(({ open, onClose, onSelect, loading }: DownloadFormatModalProps) => {
  const theme = useTheme()
  const { billing } = useStore()

  return (
    <Dialog
      open={open}
      onClose={onClose}>
      <DialogTitle variant="h3">Kies downloadformaat</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ minWidth: 400, pt: 1 }}>
          <Button
            variant="outlined"
            onClick={() => onSelect('pdf')}
            disabled={loading}
            startIcon={<PictureAsPdf />}
            sx={{
              justifyContent: 'flex-start',
              padding: theme.spacing(2),
              textAlign: 'left',
            }}>
            <Stack spacing={0.5}>
              <Typography variant="body1" fontWeight={600}>
                Alleen PDF
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Download factuur als PDF bestand
              </Typography>
            </Stack>
          </Button>
          <Button
            variant="outlined"
            onClick={() => onSelect('pdf_ubl')}
            disabled={loading || !billing.isPro}
            startIcon={!billing.isPro ? <Lock /> : <FolderZip />}
            sx={{
              justifyContent: 'flex-start',
              padding: theme.spacing(2),
              textAlign: 'left',
            }}>
            <Stack spacing={0.5} sx={{ flex: 1 }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body1" fontWeight={600}>
                  PDF + UBL (ZIP)
                </Typography>
                {!billing.isPro && (
                  <Chip
                    label="PRO"
                    size="small"
                    color="primary"
                    sx={{ height: 20, fontSize: '0.75rem' }}
                  />
                )}
              </Stack>
              <Typography variant="body2" color="text.secondary">
                {!billing.isPro
                  ? 'Upgrade naar PRO voor UBL e-facturering voor je boekhouder'
                  : 'Download factuur als ZIP met PDF en UBL bestand'}
              </Typography>
            </Stack>
          </Button>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ padding: theme.spacing(2.5) }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}>
          Annuleren
        </Button>
      </DialogActions>
    </Dialog>
  )
})
